import React, { useMemo } from "react";
import { StyleSheet } from "react-native";
import NtTouchableEffect from "./NtTouchableEffect";
import NtText from "./NtText";
import { useTheme } from "../context/ThemeContext";

/**
 * Single tab pill.
 *
 * `flat` mode (default false): item is transparent — the tab does NOT
 * draw its own background or border. Use this when the parent renders an
 * animated slider behind the active tab (see NtTabController).
 */
function NtTabItem({
  containerStyle,
  textStyle,
  item,
  onPress,
  selected = false,
  flat = false,
}) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  return (
    <NtTouchableEffect
      style={[
        styles.container,
        flat ? styles.flat : (selected ? styles.selected : null),
        containerStyle,
      ]}
      onPress={onPress}
    >
      <NtText
        style={[
          styles.label,
          selected ? styles.labelSelected : null,
          textStyle,
        ]}
      >
        {item?.title}
      </NtText>
    </NtTouchableEffect>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    container: {
      paddingHorizontal: 10,
      paddingVertical: 4,
      borderRadius: t.radius,
      borderWidth: 1,
      marginRight: 8,
      borderColor: t.border,
      backgroundColor: t.surface2,
    },
    flat: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      marginRight: 0,
    },
    selected: {
      backgroundColor: t.brand,
      borderColor: t.brand,
    },
    label: {
      fontSize: 12,
      fontWeight: "500",
      color: t.textDim,
    },
    labelSelected: {
      color: "#ffffff",
      fontWeight: "600",
    },
  });

export default NtTabItem;
